export default __webpack_public_path__ + "static/media/protect-your-vehicle.d7513b65.svg";